import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { Add } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import { AuthContext } from "../../../../context/AuthContext";

const filter = createFilterOptions();

const SelectSalesRep = ({
  companyId,
  value,
  label = "Sales Rep",
  onUpdate,
  disabled,
  onBlur,
  error,
  helperText,
  ...props
}) => {
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [salesReps, setSalesReps] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  const getSalesReps = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/users`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status == 200 || response.status == 201) {
        setSalesReps(response.data.employees);
        setHasLoaded(true);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // If the value is set but the list isn't loaded yet then load the list
  // If this isn't done, the value is set on the state but not shown on the TextField
  // because it matches nothing on a list that is empty
  useEffect(() => {
    if (salesReps.length == 0) {
      getSalesReps();
    }
  }, [value]);

  if (companyId && hasLoaded) {
    // This makes sure the sales rep list is loaded before showing the autocomplete
    // (because the sales rep is updated when the customer is selected)
    return (
      <>
        <Autocomplete
          value={value}
          disabled={disabled}
          handleHomeEndKeys
          onChange={(event, newValue) => {
            // console.log("Value is object or null", newValue);
            // console.log("SET VALUE", newValue);
            if (onUpdate) onUpdate(newValue ?? null);
          }}
          onInputChange={() => {
            // console.log("onInputChange");
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);

            return filtered;
          }}
          options={salesReps}
          getOptionLabel={(option) => {
            //   console.log("Option", option);
            // for example value selected with enter, right from the input
            if (typeof option === "string") {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            return option.fullName;
          }}
          selectOnFocus
          clearOnBlur
          isOptionEqualToValue={(option, value) => {
            //  The "selected" prop on renderOption depends on this
            return value.fullName == option.fullName;
          }}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;

            if (option.id)
              return (
                <li key={key} {...optionProps}>
                  {option.fullName}
                </li>
              );
            else
              return (
                <li key={key} {...optionProps}>
                  <Add style={{ marginRight: 8 }} />

                  {option.id ? option.fullName : `Add "${option.fullName}"`}
                </li>
              );
          }}
          freeSolo
          renderInput={(params) => (
            <TextField
              {...params}
              size={props.size ? props.size : "small"}
              label={label}
              sx={{
                width: "100%",
              }}
              variant="outlined" // filled, outlined, standard
              onBlur={onBlur}
              error={error}
              helperText={helperText}
            />
          )}
        />
      </>
    );
  }
};

export default SelectSalesRep;
